import { useCallback, useMemo } from 'react';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import type { MenuOptions, MenuState } from '../model';

import { getOptionsProvider } from '@shared/OptionsProvider';

export const initialState: Partial<MenuState> = {
  items: [],
  trnItem: null,
};

const itemsSlice = devtools<MenuState>(
  (set) => ({
    items: initialState.items,
    trnItem: initialState.trnItem,
    setHiddenMenuItems: (ids: string[]) =>
      set(
        (state) => ({
          items: state.items.map((i) => ({
            ...i,
            hidden: ids.includes(i.id),
          })),
        }),
        false,
        'menu/setHiddenMenuItems',
      ),
  }),
  { name: 'menu' },
);

export const useMenuStore = create<MenuState>()(itemsSlice);

const useMenuItems = () => {
  const items = useMenuStore((state) => state.items);
  const trnItem = useMenuStore((state) => state.trnItem);
  const setHiddenMenuItemsAction = useMenuStore((state) => state.setHiddenMenuItems);
  const moreItems = useMemo(() => items.filter((i) => i.hidden), [items]);

  const setHiddenMenuItems = useCallback(
    (itemIds: string[]) => {
      setHiddenMenuItemsAction(itemIds);
    },
    [setHiddenMenuItemsAction],
  );

  return { items, trnItem, moreItems, setHiddenMenuItems };
};

export const { OptionsProvider: MenuOptionsProvider, useOptions: useMenuOptions } = getOptionsProvider<MenuOptions>();

export { useMenuItems };
